import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';

interface CkeditorContentSkeletonProps {
  hideTitle?: boolean;
}
export const CkeditorContentSkeleton: React.FC<CkeditorContentSkeletonProps> = ({ hideTitle }) => {
  return (
    <Box>
      {!hideTitle && (
        <Skeleton variant="rectangular" width="clamp(15rem, 25rem, 100%)" height="2.5rem" sx={{ mb: 2.5 }} />
      )}
      <Grid rowSpacing={2} container direction="column">
        {_.times(2, _.stubArray).map((_item, index) => (
          <Grid item key={index}>
            <Skeleton variant="text" width="100%" />
            <Skeleton variant="text" width="100%" />
            <Skeleton variant="text" width="75%" />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
